import React from "react";

export const TextDecrypt = (props) => {
  return (
    <p>
      {props.text}
      {" "}
    </p>
  );
};
